import React, { FunctionComponent } from "react";
import { ListItemButton, Stack } from "@mui/material";
import styles from "./styles.module.scss";
import { IAlbum } from "../../../hooks/albums";
import { strings } from "../../../localization/LocalizedStrings";

export const BoxSetListItem: FunctionComponent<IBoxSetListItemProps> = ({ boxSet, onClick }) => {
  return (
    <ListItemButton disableGutters onClick={onClick}>
      <Stack direction={"row"} flexGrow={1} spacing={1} alignItems={"center"} paddingRight={1}>
        <p className={styles.name}>{boxSet.name}</p>
        <p className={styles.boxSet}>{strings.box_set_title}</p>
      </Stack>
    </ListItemButton>
  );
};

export interface IBoxSetListItemProps {
  boxSet: IAlbum;
  onClick: () => void;
}
